export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50 scroll-mt-[64px]">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            联系我们
          </h2>
          <p className="text-sm text-foreground-500">有建议、投稿或合作意向？随时与耽美漫画网取得联系</p>
        </div>

        <div className="max-w-lg mx-auto bg-background-100 rounded-lg p-6 md:p-8">
          <div className="grid grid-cols-1 gap-5">
            <div className="flex items-center gap-4">
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-mail-line text-lg text-primary-600"></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-xs text-foreground-500 mb-0.5">投稿与合作</div>
                <div className="text-sm text-foreground-900 font-medium">contact@danmeicomics.com</div>
              </div>
            </div>

            <div className="flex items-center gap-4">
              <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-question-answer-line text-lg text-accent-600"></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-xs text-foreground-500 mb-0.5">读者反馈</div>
                <div className="text-sm text-foreground-900 font-medium">feedback@danmeicomics.com</div>
              </div>
            </div>

            <div className="flex items-center gap-4">
              <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-shake-hands-line text-lg text-secondary-600"></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-xs text-foreground-500 mb-0.5">商务合作</div>
                <div className="text-sm text-foreground-900 font-medium">biz@danmeicomics.com</div>
              </div>
            </div>

            <div className="flex items-center gap-4">
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-wechat-line text-lg text-primary-600"></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-xs text-foreground-500 mb-0.5">微信公众号</div>
                <div className="text-sm text-foreground-900 font-medium">耽美漫画网</div>
              </div>
            </div>
          </div>

          <div className="mt-6 pt-5 border-t border-background-200/70 text-center">
            <p className="text-xs text-foreground-500 leading-relaxed">
              我们会在收到邮件后 24 小时内回复。欢迎漫画作者投稿合作，也期待读者朋友们的宝贵建议！
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}